import React, { useEffect, useState } from 'react';

// import footer_logo from '../../assets/img/footer_logo.svg'

// import facebook from '../../assets/images/facebook.svg'
// import inst from '../../assets/images/inst.svg'
// import youtube from '../../assets/images/youtube.svg'
// import twitter from '../../assets/images/twitter.svg'
import logo_white from '../../assets/images/logo_white.svg'
import mwaliLogo from '../../assets/images/Mwali_security_logo.png'



import cl from './Footer.module.css'
import { NavLink, useLocation } from 'react-router-dom';


const Footer = () => {

    
    const [hideFooter, setHideFooter] = useState(false)

    // const urlsArray = ['/login', '/sign-up', '/personal-account']
    
    const location = useLocation();

    useEffect(() => {
       
        if (window.location.pathname.includes('/login')
            || window.location.pathname.includes('/sign-up')
            || window.location.pathname.includes('/personal_account')
        ) {
            setHideFooter(true)
        } else {
            setHideFooter(false)
        }
    }, [window.location.pathname])
    return hideFooter ? null : (
        
        <div className={cl.footer_container}>
                <div className={cl.left_side_footer}>
                    <div className={cl.upper_footer_content}>
                        <img src={logo_white} alt="#footer_logo" />
                        
                    </div>
                    <p className={cl.footer_descr}>
                        Fortres BanCorp is licensed as a Major Payment Institution under Singapore's Payment Services Act for the provision of Domestic Money Transfer Services, Cross-Border Money Transfer Services and Merchant Acquisition Services. This can be confirmed on the MAS Financial Institutions Directory. Fortres BanCorp may also provide these services in conjunction with other MAS licensed or exempt partners.
                    </p>
                    {/* <div className={cl.socials_img_wrapper}>
                        <div className={cl.img_wrapper}>
                            <img src={facebook} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={inst} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={youtube} alt="#facebook" />
                        </div>
                         <div className={cl.img_wrapper}>
                            <img src={twitter} alt="#facebook" />
                        </div>
                    </div> */}
                </div>
                <div className={cl.right_side_footer}>
                    <div className={cl.links_footer_row_wrapper}>
                        <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                Support
                            </div>
                            
                            <NavLink to='/services'>
                                <div className={cl.second_item}>
                                    Services
                                </div>
                            </NavLink>
                            <NavLink to='/contact-us'>
                            <div className={cl.second_item}>
                                Contact Us
                            </div>
                            </NavLink>
                        </div>
                         <div className={cl.column_row_items}>
                            
                            <div className={cl.first_item}>
                                Company
                            </div>
                            <NavLink to='/personal'>
                            <div className={cl.second_item}>
                                Personal
                            </div>
                            </NavLink>
                            <NavLink to='/about-us'>
                            <div className={cl.second_item}>
                                About Us
                            </div>
                            </NavLink>
                            

                        </div>
                         <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                Legal
                            </div>
                            <NavLink to='/terms'>
                            <div className={cl.second_item}>
                                Privacy & Terms
                            </div>
                            </NavLink>
                            
                        </div>
                        <div className={cl.column_row_items}>
                            <div className={cl.first_item}>
                                License Number
                            </div>
                            <div className={cl.mwali_image_wrapper}>
                                <img src={mwaliLogo} alt=""/>
                            </div>
                            <h3 className={cl.mwali_number}>B2026134</h3>
                            <a href='https://mwaliregistrar.com/list_of_entities/verify/581'>
                                <div className={[cl.second_item, cl.footer_mwali_link].join(' ')}>
                                    Link to license
                                </div>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Footer;